import { useActiveCard } from '@/forms/composables/useActiveCard';
import type { Ref } from 'vue';

export interface FormRef {
    save: () => Promise<void>;
    onDiscard: () => void;
    resetForm: () => void;
}

export function useFormRegistry() {
    const { resetActiveCard } = useActiveCard();
    const registry = new Map<string, Ref<FormRef | null>>();

    function register(id: string, ref: Ref<FormRef | null>) {
        registry.set(id, ref);
    }

    async function saveForm(id: string) {
        await registry.get(id)?.value?.save();
        resetActiveCard();
    }

    function discardChanges(id: string) {
        registry.get(id)?.value?.onDiscard();
        resetActiveCard();
    }

    function leaveEditMode(id: string) {
        registry.get(id)?.value?.resetForm();
        resetActiveCard();
    }

    function resetAll() {
        registry.forEach((ref) => ref.value?.resetForm());
        resetActiveCard();
    }

    return { register, saveForm, discardChanges, leaveEditMode, resetAll };
}
